import CloseIcon from '@/components/svgs/Close'
import Logo from '@/components/svgs/Logo'
import { colors } from '@/constants/colors'
import { Button, ButtonText } from '@/ui/core/button'
import { Header } from '@/ui/core/header'
import { Screen } from '@/ui/core/screen'
import { HStack, VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { Link } from 'expo-router'
import { Platform, Pressable, View } from 'react-native'

const ReschedulePerioConfirmation = ({
	isCancellingAppointment = false,
	onConfirmPressed = () => {},
}) => {
	return (
		<Screen className="bg-palette_1 flex-1" preset="fixed">
			<HStack className="pl-10 pr-4 lg:pt-2 web:pt-1 native:mt-[2.6rem] justify-between items-center">
				<View>
					<Logo />
				</View>
				<Link asChild href="../">
					<Pressable className="p-8">
						<CloseIcon
							color={colors.palette_6}
							height={Platform.OS === 'web' ? 16 : 18}
							width={Platform.OS === 'web' ? 16 : 18}
						/>
					</Pressable>
				</Link>
			</HStack>
			<VStack className="justify-center flex-1 items-center" gap={64}>
				<VStack className="justify-center items-center px-16" gap={32}>
					<Header className="text-center text-balance native:max-w-72" variant="h2">
						Just a heads up.
					</Header>
					<Text className="text-balance text-palette_6 text-center lg:max-w-96">
						By continuing, your periodontal therapy plan will be cancelled. Your Care Team
						will reach out and help schedule new times.
					</Text>
				</VStack>
				<VStack className="items-center justify-center max-w-48" gap={16}>
					<Button isLoading={isCancellingAppointment} onPress={onConfirmPressed}>
						<ButtonText>Continue</ButtonText>
					</Button>
					<Link asChild href="../">
						<Button size="sm" variant="ghostBorderless">
							<ButtonText spacing="wide">NEVERMIND</ButtonText>
						</Button>
					</Link>
				</VStack>
			</VStack>
		</Screen>
	)
}

export { ReschedulePerioConfirmation }
